import React from 'react';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import settingsReducers from './reducers';
import settingsSagas from './sagas';
import PrivacyView from './components/PrivacyView';
import Notifications from './components/Notifications';

const sagaMiddleware = createSagaMiddleware();
const store = createStore(settingsReducers, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(settingsSagas);

export default class PrivacySettingsApp extends React.Component {
    render() {
        return (
            <Provider store={store}>
                <div>
                    <Notifications />
                    <PrivacyView />
                </div>
            </Provider>
        );
    }
}




// WEBPACK FOOTER //
// ./src/UserSettings/privacySettingsApp.js